export default [
   {
      "title":"12年级数学 (Lesson1)",
      "allDay":false,
      "start":"2018-01-02T14:00:00.000Z",
      "end":"2018-01-02T15:00:00.000Z",
      "id":968,
      "lName":"Lesson 1",
      "lStartTime":"2018-01-02 06:00",
      "lEndTime":"2018-01-02 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":1,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Yes! 500 (Lesson1)",
      "allDay":false,
      "start":"2018-01-02T14:00:00.000Z",
      "end":"2018-01-02T15:00:00.000Z",
      "id":1000,
      "lName":"Lesson 1",
      "lStartTime":"2018-01-02 06:00",
      "lEndTime":"2018-01-02 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":1,
      "teacher_list":[

      ]
   },
   {
      "title":"ABC A (Lesson1)",
      "allDay":false,
      "start":"2018-01-02T14:00:00.000Z",
      "end":"2018-01-02T15:00:00.000Z",
      "id":1037,
      "lName":"Lesson 1",
      "lStartTime":"2018-01-02 06:00",
      "lEndTime":"2018-01-02 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":741,
      "lClassroom":null,
      "class_name":"ABC A",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":1,
      "lesson_number":1,
      "teacher_list":[

      ]
   },
   {
      "title":"Peeling potatoes (Lesson5)",
      "allDay":false,
      "start":"2018-01-02T21:00:00.000Z",
      "end":"2018-01-02T23:00:00.000Z",
      "id":895,
      "lName":"Lesson 5",
      "lStartTime":"2018-01-02 13:00",
      "lEndTime":"2018-01-02 15:00",
      "lDuration":"120.0",
      "lState":0,
      "lCalendarColor":"#8bc34a",
      "lClass":656,
      "lClassroom":58,
      "class_name":"Peeling potatoes",
      "class_type":0,
      "calendarColor":"#8bc34a",
      "classroom_name":"Room R",
      "student_amount":0,
      "lesson_number":5,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"12年级数学 (Lesson2)",
      "allDay":false,
      "start":"2018-01-04T14:00:00.000Z",
      "end":"2018-01-04T15:00:00.000Z",
      "id":969,
      "lName":"Lesson 2",
      "lStartTime":"2018-01-04 06:00",
      "lEndTime":"2018-01-04 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":2,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Class 3 (Lesson1)",
      "allDay":false,
      "start":"2018-01-04T14:00:00.000Z",
      "end":"2018-01-04T15:00:00.000Z",
      "id":993,
      "lName":"Lesson 1",
      "lStartTime":"2018-01-04 06:00",
      "lEndTime":"2018-01-04 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":727,
      "lClassroom":null,
      "class_name":"Class 3",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":1,
      "teacher_list":[

      ]
   },
   {
      "title":"Yes! 500 (Lesson2)",
      "allDay":false,
      "start":"2018-01-04T14:00:00.000Z",
      "end":"2018-01-04T15:00:00.000Z",
      "id":1001,
      "lName":"Lesson 2",
      "lStartTime":"2018-01-04 06:00",
      "lEndTime":"2018-01-04 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":2,
      "teacher_list":[

      ]
   },
   {
      "title":"Peeling potatoes (Lesson6)",
      "allDay":false,
      "start":"2018-01-04T21:00:00.000Z",
      "end":"2018-01-04T23:00:00.000Z",
      "id":896,
      "lName":"Lesson 6",
      "lStartTime":"2018-01-04 13:00",
      "lEndTime":"2018-01-04 15:00",
      "lDuration":"120.0",
      "lState":0,
      "lCalendarColor":"#8bc34a",
      "lClass":656,
      "lClassroom":58,
      "class_name":"Peeling potatoes",
      "class_type":0,
      "calendarColor":"#8bc34a",
      "classroom_name":"Room R",
      "student_amount":0,
      "lesson_number":6,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"12年级数学 (Lesson3)",
      "allDay":false,
      "start":"2018-01-06T14:00:00.000Z",
      "end":"2018-01-06T15:00:00.000Z",
      "id":970,
      "lName":"Lesson 3",
      "lStartTime":"2018-01-06 06:00",
      "lEndTime":"2018-01-06 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":3,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Class 3 (Lesson2)",
      "allDay":false,
      "start":"2018-01-06T14:00:00.000Z",
      "end":"2018-01-06T15:00:00.000Z",
      "id":994,
      "lName":"Lesson 2",
      "lStartTime":"2018-01-06 06:00",
      "lEndTime":"2018-01-06 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":727,
      "lClassroom":null,
      "class_name":"Class 3",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":2,
      "teacher_list":[

      ]
   },
   {
      "title":"Yes! 500 (Lesson3)",
      "allDay":false,
      "start":"2018-01-06T14:00:00.000Z",
      "end":"2018-01-06T15:00:00.000Z",
      "id":1002,
      "lName":"Lesson 3",
      "lStartTime":"2018-01-06 06:00",
      "lEndTime":"2018-01-06 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":3,
      "teacher_list":[

      ]
   },
   {
      "title":"12年级数学 (Lesson4)",
      "allDay":false,
      "start":"2018-01-09T14:00:00.000Z",
      "end":"2018-01-09T15:00:00.000Z",
      "id":971,
      "lName":"Lesson 4",
      "lStartTime":"2018-01-09 06:00",
      "lEndTime":"2018-01-09 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":4,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Class 3 (Lesson3)",
      "allDay":false,
      "start":"2018-01-09T14:00:00.000Z",
      "end":"2018-01-09T15:00:00.000Z",
      "id":995,
      "lName":"Lesson 3",
      "lStartTime":"2018-01-09 06:00",
      "lEndTime":"2018-01-09 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":727,
      "lClassroom":null,
      "class_name":"Class 3",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":3,
      "teacher_list":[

      ]
   },
   {
      "title":"Yes! 500 (Lesson4)",
      "allDay":false,
      "start":"2018-01-09T14:00:00.000Z",
      "end":"2018-01-09T15:00:00.000Z",
      "id":1003,
      "lName":"Lesson 4",
      "lStartTime":"2018-01-09 06:00",
      "lEndTime":"2018-01-09 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":4,
      "teacher_list":[

      ]
   },
   {
      "title":"Peeling potatoes (Lesson7)",
      "allDay":false,
      "start":"2018-01-09T21:00:00.000Z",
      "end":"2018-01-09T23:00:00.000Z",
      "id":897,
      "lName":"Lesson 7",
      "lStartTime":"2018-01-09 13:00",
      "lEndTime":"2018-01-09 15:00",
      "lDuration":"120.0",
      "lState":0,
      "lCalendarColor":"#8bc34a",
      "lClass":656,
      "lClassroom":58,
      "class_name":"Peeling potatoes",
      "class_type":0,
      "calendarColor":"#8bc34a",
      "classroom_name":"Room R",
      "student_amount":0,
      "lesson_number":7,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"12年级数学 (Lesson5)",
      "allDay":false,
      "start":"2018-01-11T14:00:00.000Z",
      "end":"2018-01-11T15:00:00.000Z",
      "id":972,
      "lName":"Lesson 5",
      "lStartTime":"2018-01-11 06:00",
      "lEndTime":"2018-01-11 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":5,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Class 3 (Lesson4)",
      "allDay":false,
      "start":"2018-01-11T14:00:00.000Z",
      "end":"2018-01-11T15:00:00.000Z",
      "id":996,
      "lName":"Lesson 4",
      "lStartTime":"2018-01-11 06:00",
      "lEndTime":"2018-01-11 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":727,
      "lClassroom":null,
      "class_name":"Class 3",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":4,
      "teacher_list":[

      ]
   },
   {
      "title":"Yes! 500 (Lesson5)",
      "allDay":false,
      "start":"2018-01-11T14:00:00.000Z",
      "end":"2018-01-11T15:00:00.000Z",
      "id":1004,
      "lName":"Lesson 5",
      "lStartTime":"2018-01-11 06:00",
      "lEndTime":"2018-01-11 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":5,
      "teacher_list":[

      ]
   },
   {
      "title":"Peeling potatoes (Lesson8)",
      "allDay":false,
      "start":"2018-01-11T21:00:00.000Z",
      "end":"2018-01-11T23:00:00.000Z",
      "id":898,
      "lName":"Lesson 8",
      "lStartTime":"2018-01-11 13:00",
      "lEndTime":"2018-01-11 15:00",
      "lDuration":"120.0",
      "lState":0,
      "lCalendarColor":"#8bc34a",
      "lClass":656,
      "lClassroom":58,
      "class_name":"Peeling potatoes",
      "class_type":0,
      "calendarColor":"#8bc34a",
      "classroom_name":"Room R",
      "student_amount":0,
      "lesson_number":8,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"12年级数学 (Lesson6)",
      "allDay":false,
      "start":"2018-01-13T14:00:00.000Z",
      "end":"2018-01-13T15:00:00.000Z",
      "id":973,
      "lName":"Lesson 6",
      "lStartTime":"2018-01-13 06:00",
      "lEndTime":"2018-01-13 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":6,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Class 3 (Lesson5)",
      "allDay":false,
      "start":"2018-01-13T14:00:00.000Z",
      "end":"2018-01-13T15:00:00.000Z",
      "id":997,
      "lName":"Lesson 5",
      "lStartTime":"2018-01-13 06:00",
      "lEndTime":"2018-01-13 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":727,
      "lClassroom":null,
      "class_name":"Class 3",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":5,
      "teacher_list":[

      ]
   },
   {
      "title":"Yes! 500 (Lesson6)",
      "allDay":false,
      "start":"2018-01-13T14:00:00.000Z",
      "end":"2018-01-13T15:00:00.000Z",
      "id":1005,
      "lName":"Lesson 6",
      "lStartTime":"2018-01-13 06:00",
      "lEndTime":"2018-01-13 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":6,
      "teacher_list":[

      ]
   },
   {
      "title":"12年级数学 (Lesson7)",
      "allDay":false,
      "start":"2018-01-16T14:00:00.000Z",
      "end":"2018-01-16T15:00:00.000Z",
      "id":974,
      "lName":"Lesson 7",
      "lStartTime":"2018-01-16 06:00",
      "lEndTime":"2018-01-16 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":7,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Class 3 (Lesson6)",
      "allDay":false,
      "start":"2018-01-16T14:00:00.000Z",
      "end":"2018-01-16T15:00:00.000Z",
      "id":998,
      "lName":"Lesson 6",
      "lStartTime":"2018-01-16 06:00",
      "lEndTime":"2018-01-16 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":727,
      "lClassroom":null,
      "class_name":"Class 3",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":6,
      "teacher_list":[

      ]
   },
   {
      "title":"Yes! 500 (Lesson7)",
      "allDay":false,
      "start":"2018-01-16T14:00:00.000Z",
      "end":"2018-01-16T15:00:00.000Z",
      "id":1006,
      "lName":"Lesson 7",
      "lStartTime":"2018-01-16 06:00",
      "lEndTime":"2018-01-16 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":7,
      "teacher_list":[

      ]
   },
   {
      "title":"Peeling potatoes (Lesson9)",
      "allDay":false,
      "start":"2018-01-16T21:00:00.000Z",
      "end":"2018-01-16T23:00:00.000Z",
      "id":899,
      "lName":"Lesson 9",
      "lStartTime":"2018-01-16 13:00",
      "lEndTime":"2018-01-16 15:00",
      "lDuration":"120.0",
      "lState":0,
      "lCalendarColor":"#8bc34a",
      "lClass":656,
      "lClassroom":58,
      "class_name":"Peeling potatoes",
      "class_type":0,
      "calendarColor":"#8bc34a",
      "classroom_name":"Room R",
      "student_amount":0,
      "lesson_number":9,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"12年级数学 (Lesson8)",
      "allDay":false,
      "start":"2018-01-18T14:00:00.000Z",
      "end":"2018-01-18T15:00:00.000Z",
      "id":975,
      "lName":"Lesson 8",
      "lStartTime":"2018-01-18 06:00",
      "lEndTime":"2018-01-18 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":8,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Class 3 (Lesson7)",
      "allDay":false,
      "start":"2018-01-18T14:00:00.000Z",
      "end":"2018-01-18T15:00:00.000Z",
      "id":999,
      "lName":"Lesson 7",
      "lStartTime":"2018-01-18 06:00",
      "lEndTime":"2018-01-18 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":727,
      "lClassroom":null,
      "class_name":"Class 3",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":7,
      "teacher_list":[

      ]
   },
   {
      "title":"Yes! 500 (Lesson8)",
      "allDay":false,
      "start":"2018-01-18T14:00:00.000Z",
      "end":"2018-01-18T15:00:00.000Z",
      "id":1007,
      "lName":"Lesson 8",
      "lStartTime":"2018-01-18 06:00",
      "lEndTime":"2018-01-18 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":8,
      "teacher_list":[

      ]
   },
   {
      "title":"Peeling potatoes (Lesson10)",
      "allDay":false,
      "start":"2018-01-18T21:00:00.000Z",
      "end":"2018-01-18T23:00:00.000Z",
      "id":900,
      "lName":"Lesson 10",
      "lStartTime":"2018-01-18 13:00",
      "lEndTime":"2018-01-18 15:00",
      "lDuration":"120.0",
      "lState":0,
      "lCalendarColor":"#8bc34a",
      "lClass":656,
      "lClassroom":58,
      "class_name":"Peeling potatoes",
      "class_type":0,
      "calendarColor":"#8bc34a",
      "classroom_name":"Room R",
      "student_amount":0,
      "lesson_number":10,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"12年级数学 (Lesson9)",
      "allDay":false,
      "start":"2018-01-20T14:00:00.000Z",
      "end":"2018-01-20T15:00:00.000Z",
      "id":976,
      "lName":"Lesson 9",
      "lStartTime":"2018-01-20 06:00",
      "lEndTime":"2018-01-20 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":9,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Yes! 500 (Lesson9)",
      "allDay":false,
      "start":"2018-01-20T14:00:00.000Z",
      "end":"2018-01-20T15:00:00.000Z",
      "id":1008,
      "lName":"Lesson 9",
      "lStartTime":"2018-01-20 06:00",
      "lEndTime":"2018-01-20 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":9,
      "teacher_list":[

      ]
   },
   {
      "title":"12年级数学 (Lesson10)",
      "allDay":false,
      "start":"2018-01-23T14:00:00.000Z",
      "end":"2018-01-23T15:00:00.000Z",
      "id":977,
      "lName":"Lesson 10",
      "lStartTime":"2018-01-23 06:00",
      "lEndTime":"2018-01-23 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":10,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Yes! 500 (Lesson10)",
      "allDay":false,
      "start":"2018-01-23T14:00:00.000Z",
      "end":"2018-01-23T15:00:00.000Z",
      "id":1009,
      "lName":"Lesson 10",
      "lStartTime":"2018-01-23 06:00",
      "lEndTime":"2018-01-23 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":10,
      "teacher_list":[

      ]
   },
   {
      "title":"12年级数学 (Lesson11)",
      "allDay":false,
      "start":"2018-01-25T14:00:00.000Z",
      "end":"2018-01-25T15:00:00.000Z",
      "id":978,
      "lName":"Lesson 11",
      "lStartTime":"2018-01-25 06:00",
      "lEndTime":"2018-01-25 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":11,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Yes! 500 (Lesson11)",
      "allDay":false,
      "start":"2018-01-25T14:00:00.000Z",
      "end":"2018-01-25T15:00:00.000Z",
      "id":1010,
      "lName":"Lesson 11",
      "lStartTime":"2018-01-25 06:00",
      "lEndTime":"2018-01-25 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":11,
      "teacher_list":[

      ]
   },
   {
      "title":"12年级数学 (Lesson12)",
      "allDay":false,
      "start":"2018-01-27T14:00:00.000Z",
      "end":"2018-01-27T15:00:00.000Z",
      "id":979,
      "lName":"Lesson 12",
      "lStartTime":"2018-01-27 06:00",
      "lEndTime":"2018-01-27 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":12,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Yes! 500 (Lesson12)",
      "allDay":false,
      "start":"2018-01-27T14:00:00.000Z",
      "end":"2018-01-27T15:00:00.000Z",
      "id":1011,
      "lName":"Lesson 12",
      "lStartTime":"2018-01-27 06:00",
      "lEndTime":"2018-01-27 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":12,
      "teacher_list":[

      ]
   },
   {
      "title":"12年级数学 (Lesson13)",
      "allDay":false,
      "start":"2018-01-30T14:00:00.000Z",
      "end":"2018-01-30T15:00:00.000Z",
      "id":980,
      "lName":"Lesson 13",
      "lStartTime":"2018-01-30 06:00",
      "lEndTime":"2018-01-30 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":717,
      "lClassroom":null,
      "class_name":"12年级数学",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":13,
      "teacher_list":[
         {
            "id":282,
            "stName":"Ryan Lee"
         }
      ]
   },
   {
      "title":"Yes! 500 (Lesson13)",
      "allDay":false,
      "start":"2018-01-30T14:00:00.000Z",
      "end":"2018-01-30T15:00:00.000Z",
      "id":1012,
      "lName":"Lesson 13",
      "lStartTime":"2018-01-30 06:00",
      "lEndTime":"2018-01-30 07:00",
      "lDuration":"60.0",
      "lState":0,
      "lCalendarColor":"",
      "lClass":731,
      "lClassroom":null,
      "class_name":"Yes! 500",
      "class_type":0,
      "calendarColor":"",
      "classroom_name":"",
      "student_amount":0,
      "lesson_number":13,
      "teacher_list":[

      ]
   }
];



// WEBPACK FOOTER //
// ./src/containers/pages/Schedule/test-events.js